import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPasswordComponent } from '../header-pages/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from '../header-pages/change-password/change-password.component';
import { PrivacyPolicyComponent } from '../header-pages/privacy-policy/privacy-policy.component';
import { dashCaseToCamelCase } from '@angular/compiler/src/util';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  Username = '';
  Password = '';
  showPassword = false;
  currentUser: any = {};

  constructor(
    public sharedService: SharedService,
    private loginService: LoginService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    if (this.sharedService.currentUser) {
      this.router.navigate(['/dashboard']);
    }
  }

  ngOnDestroy() {
    this.sharedService.showErrorMessage.emit({ error: "", displayError: false });
    this.sharedService.showSuccessMessage.emit({ success: "", displaySuccess: false });
    this.sharedService.showPopupErrorMessage.emit({ error: "", displayError: false });
  }

  ngOnInit() { }

  onSubmitLogin() {
    this.sharedService.showPopupErrorMessage.emit({ error: "", displayError: false });
    let errors = '';
    if (!this.Username || this.Username === '' || this.Username == null) {
      errors += 'Please insert Username.<br/>';
      // this.sharedService.showErrorMessage.emit({ error: "Please insert Username", displayError: true });
      // return;
    }
    if (!this.Password || this.Password === '' || this.Password == null) {
      errors += 'Please insert Password.<br/>';
      // this.sharedService.showErrorMessage.emit({ error: "Please insert Password", displayError: true });
      // return;
    }

    if (errors) {
      this.sharedService.showPopupErrorMessage.emit({ error: errors, displayError: true });
      return;
    }

    let encryptedUser = {
      ipAddress: '',
      username: this.Username,
      password: this.sharedService.encryptpassword(this.Password)
    };

    //first get ip address of the user
    this.loginService.getIPAddress().subscribe((res: any) => {
      if (res) {
        encryptedUser.ipAddress = res.ip
        //now allow user to login
        this.loginService.userLogIn(encryptedUser).subscribe(data => {
          if (data && data.User) {
            this.currentUser = data.User;
            this.sharedService.setDataToStorage('token', ('Bearer ' + data.access_token));

            if (data.User.PasswordExpired)
              this.changePassword();
            else if (!data.User.DateLicenseAccepted)
              this.privacyPolicy();
            else
              this.setUserInfo();// this.sharedService.showToastr('success', data.User.Username, 'Welcome');
            
          }
        }, err => {
          if (err && err.error.ValidationErrors && err.error.ValidationErrors.length > 0) 
            this.sharedService.showErrorMessage.emit({ error: err.error.ValidationErrors[0].ErrorMessage, displayError: true });
          else 
            this.sharedService.showErrorMessage.emit({ error: "failed to login.", displayError: true });
          
        });
      }
      else {
        //display error if the ipaddress is not obtained.
        this.sharedService.showErrorMessage.emit({ error: "Error in logging into our system. Please contact your administrator.", displayError: true });
      }
    });

  }

  forgotPassword() {
    const dialogRef = this.dialog.open(ForgotPasswordComponent, {
      width: '30%',
    });
  }

  changePassword() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '40%',
      disableClose: true,
      data: {
        title: 'Please reset the temporary password which is created by System or Lab Admin',
        userId: this.currentUser.Id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.Username = '';
        this.Password = '';
        this.sharedService.showSuccessMessage.emit({ success: "Password changed successfully.", displaySuccess: true });
      }
    });
  }

  privacyPolicy() {
    const dialogRef = this.dialog.open(PrivacyPolicyComponent, {
      width: '80%',
      data: {
        url: '../../../assets/images/PrivacyPolicy.pdf',
        isFromLogin: true,
        userId: this.currentUser.Id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.setUserInfo();
      }
    });
  }

  setUserInfo() {
    this.currentUser.LoginDateTime = moment(new Date()).format('MM/DD/YYYY, dddd h:mm A');
    this.sharedService.setDataToStorage('user', this.currentUser);
    
    if (this.currentUser && this.currentUser.LabclientId == 0)
      this.router.navigate(['/dashboard']);
    else
      this.router.navigate(['/accession/orders']);
      
    this.sharedService.setLogOutTimer();
  }

}
